const visit = (object, callback) => {
  callback(object);
  (object.getObjects?.() || []).forEach((child) => visit(child, callback));
};

export const rememberClipartColors = (object, legacyColors) => {
  if (!object || Array.isArray(object.clipartOriginalColors)) return;
  const colors = [];
  visit(object, (node) => {
    const fill = legacyColors?.has(node) ? legacyColors.get(node) : node.fill;
    colors.push(fill ?? null);
  });
  object.set('clipartOriginalColors', colors);
};

export const resetClipartColors = (object, legacyColors) => {
  rememberClipartColors(object, legacyColors);
  if (!object?.clipartOriginalColors) return false;
  let index = 0;
  visit(object, (node) => {
    node.set('fill', object.clipartOriginalColors[index++]);
    node.dirty = true;
  });
  object.dirty = true;
  return true;
};

export const getClipartColors = (object) => {
  const colors = new Set();
  if (object) visit(object, (node) => {
    if (!node.getObjects && node.fill) colors.add(node.fill);
  });
  return Array.from(colors);
};
